<template>
  <div class="sb-stage">
    <button class="sb-cta" aria-label="Starte Bestellung">
      <div class="content-wrapper">
        <h2 class="label">STARTE<br>BESTELLUNG</h2>
        <div class="arrow">→</div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'StarteBestellung',
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/base';

.sb-stage {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}
.sb-cta {
  width: 291px;
  height: 291px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: clamp(18px, 3vw, 34px);
  font-weight: 800;
  letter-spacing: 0.6px;
  @include button-contrast($color-primary);
  text-decoration: none;
  border: 2px solid #000;
  @include border-contrast($color-primary);
  cursor: pointer;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  transform-origin: center center;
  transform: translateZ(0);
  will-change: transform, box-shadow;
  animation: auf-und-ab 2s ease-in-out infinite;
  transition: box-shadow 0.18s ease, transform 0.12s ease;
  flex-direction: column;
  text-transform: uppercase;

  .label{
    @include text-contrast($color-primary);
  }
}
@keyframes auf-und-ab {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.12); }
}
//.sb-cta:hover {
//  box-shadow: 0 12px 28px rgba(0,0,0,0.2);
//}
.sb-cta:active {
  transform: scale(0.98);
  animation-play-state: paused;
}
//.sb-cta:focus {
//  outline: 3px solid rgba(0,0,0,0.2);
//  outline-offset: 6px;
//}
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px; /* enger zusammen */
}
.arrow {
  font-size: 48px;
  line-height: 1;
}
@media (prefers-reduced-motion: reduce) {
  .sb-cta {
    animation: none;
  }
}
</style>
